

namespace PaperTrail.NewsletterControl{

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.maximizable()
    export class PageTemplateEditorDialog extends Serenity.Extensions.GridEditorDialog<PageTemplateRow> {
        protected getFormKey() { return PageTemplateForm.formKey; }
        protected getIdProperty() { return PageTemplateRow.idProperty; }
        protected getNameProperty() { return PageTemplateRow.nameProperty; }
        protected getLocalTextPrefix() { return PageTemplateRow.localTextPrefix; }
        protected getService() { return PageTemplateService.baseUrl; }

        protected form: PageTemplateForm;
        private loadedState: string;
        //public  _claimantID: number;

        constructor() { 
            super();
            this.form = new PageTemplateForm(this.idPrefix);
            //Serenity.Extensions.DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
             
        } 


        // This is called when save/update button is pressed
        protected save(callback: (response: Serenity.SaveResponse) => void) {
            NewsletterControl.PageTemplateService.Update({
                EntityId: this.entityId,
                Entity: this.getSaveEntity()
            }, response => {
                // reload customer list just in case
                Q.reloadLookup(NewsletterControl.PageTemplateRow.lookupKey);
                Q.reloadLookup(NewsletterControl.NewsletterRow.lookupKey);
                Q.reloadLookup(NewsletterControl.NewsletterPageTemplateRow.lookupKey);

                // set flag that we are triggering customer select change event
                // otherwise active tab will change to first one
                //this.selfChange++;
                try {
                    // trigger change so that customer select updates its text
                    // in case if Company Name is changed
                    this.form.PageTemplateId.element.change();
                }
                finally {
                    //this.selfChange--;
                }
                //return true;
            });

            var prior = $(".ui-dialog").eq(-2);
            var prior2 = $(".ui-dialog").eq(-1);
            prior.trigger("changeme");
            prior2.trigger("changeme");
            if (prior.length > 0) {
                prior.change();
                Serenity.SubDialogHelper.cascade(this, prior);
            }
            super.save(callback);
        }
         

    }
}